// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"53":"webfontloader","314":"orderdetail","594":"about","852":"orders","966":"login"}[chunkId] || chunkId) + "." + {"53":"09707430","125":"c02d8a5f","278":"62f7297c","314":"2bd691a6","353":"fc841c01","594":"98ebddae","659":"6f64d59a","852":"bf352369","966":"11dc2aeb"}[chunkId] + ".js";
};